import SweetAlert from "@components/Feedback/SweetAlert/Index";

export const BlockedOptionComp = ({ title }) => {

    const handleClick = () => {
        SweetAlert.error("Erro", title);
    }

    return (
        <div className="d-flex justify-content-center">
            <i
                title={title}
                className="fa-solid fa-lock fs-6"
                style={{
                    color: '#2b97be',
                    cursor: 'pointer',
                }}
                onClick={handleClick}
            />
        </div>
    );
};